import { http } from '@/api/Connect';
import { BASE_OPERATOR } from '@/api/CopyStake/BaseUrls';
import { AxiosResponse } from 'axios';

import {
  ICopyStakeReportParams,
  ICopyStakeReportPdfParams,
  ICopyStakeReportResponse
} from '@/api/schema';

const API_PROVIDERS = (): string => `${BASE_OPERATOR()}/providers`;

export async function getCopyStakeReport(
  params: ICopyStakeReportParams
): Promise<ICopyStakeReportResponse> {
  return http
    .get(`${API_PROVIDERS()}/report`, {
      params
    })
    .then(({ data }: AxiosResponse): ICopyStakeReportResponse => data);
}

export async function getCopyStakeReportPdf(
  params: ICopyStakeReportPdfParams
): Promise<any> {
  return http.get(`${API_PROVIDERS()}/report/pdf`, {
    responseType: 'blob',
    params
  });
}
